import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpHeroComponent } from '../../Components/Help/help-hero/help-hero';
import { HelpContactComponent } from '../../Components/Help/help-contact/help-contact';
import { HelpFaqComponent } from '../../Components/Help/help-faq/help-faq';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-help-page',
  standalone: true,
  imports: [CommonModule, HelpHeroComponent, HelpContactComponent, HelpFaqComponent],
  templateUrl: './help-page.html',
})
export class HelpPageComponent implements OnInit {
  searchTerm = '';
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Help Center',
      description:
        'Get answers to common orderYaa ERP questions, or contact our support team directly by email, WhatsApp, or a quick meeting.',
      path: '/help',
    });
  }
}
